import React from 'react';
import { rotuloPedido, type Solicitacao } from '../services/solicitacaoService';

type Props = {
  solicitacao: Solicitacao;
  /** Anexos que não puderam ser enviados (o pedido em si foi). */
  falhasDeAnexo: string[];
  onVerPedido: () => void;
  onFechar: () => void;
  rotuloFechar?: string;
};

/** Confirmação depois de enviar: diz o que aconteceu e o que vem agora, sem exigir que o usuário descubra. */
const PedidoEnviado: React.FC<Props> = ({ solicitacao, falhasDeAnexo, onVerPedido, onFechar, rotuloFechar = 'Fechar' }) => (
  <div className="py-2 text-center" role="status">
    <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" className="h-8 w-8" aria-hidden="true">
        <path d="M5 13l4 4L19 7" />
      </svg>
    </span>
    <h3 className="mt-4 text-2xl font-bold text-slate-900 dark:text-slate-100">Pedido enviado!</h3>
    <p className="mt-1 text-lg font-semibold text-slate-700 dark:text-slate-200">{rotuloPedido(solicitacao)}</p>
    <p className="mx-auto mt-3 max-w-md text-base leading-7 text-slate-600 dark:text-slate-300">
      Você será avisado por e-mail e aqui no sistema quando a equipe responder.
    </p>
    {falhasDeAnexo.length > 0 && (
      <div className="mx-auto mt-4 max-w-md rounded-xl border border-amber-300 bg-amber-50 p-3 text-left text-sm text-amber-900 dark:border-amber-700/50 dark:bg-amber-500/10 dark:text-amber-200">
        <p className="font-semibold">Seu pedido foi enviado, mas estes arquivos não foram:</p>
        <ul className="mt-1 list-disc pl-5">
          {falhasDeAnexo.map((f) => <li key={f}>{f}</li>)}
        </ul>
      </div>
    )}
    <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
      <button type="button" onClick={onVerPedido}
        className="min-h-[48px] rounded-xl bg-blue-700 px-6 py-3 text-base font-semibold text-white transition hover:bg-blue-800">
        Ver meu pedido
      </button>
      <button type="button" onClick={onFechar}
        className="min-h-[48px] rounded-xl border border-slate-300 bg-white px-6 py-3 text-base font-semibold text-slate-700 transition hover:bg-slate-50 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800">
        {rotuloFechar}
      </button>
    </div>
  </div>
);

export default PedidoEnviado;
